
import React, {useEffect, useState} from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import toastr from 'toastr';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';
import { loftyHandleCountShoppingCart } from '../../util/handleCount';
import LoftyEditorJsReadOnly from '../../components/LoftyEditorJsReadOnly';
import LoftyEditorJs from '../../components/LoftyEditorJs';

import {
	addLoftyToken,
	deleteLoftytoken,
	set_lofty_global_categorias,
} from '../../actions/auth.actions';

import {customgetonecaso_69444a8ee307249250093aa0, customgetcasos_69441e8de307249250092f36 } from '../../api/casosdexito.api'

import './caso.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    






const Pcaso = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  lofty_global_categorias,
	set_lofty_global_categorias_app,

}) => {

	const [loftyres_69444a8ee307249250093aa0_component_i17de7, setloftyres_69444a8ee307249250093aa0_component_i17de7] = useState({});
	const [loftyres_69444a8ee307249250093aa0_component_iekd72, setloftyres_69444a8ee307249250093aa0_component_iekd72] = useState({});
	const [loftyres_69444a8ee307249250093aa0_component_i5gz7o, setloftyres_69444a8ee307249250093aa0_component_i5gz7o] = useState({});
	const [loftyres_69441e8de307249250092f36_component_i766ys, setloftyres_69441e8de307249250092f36_component_i766ys] = useState([]);


useEffect(() => {
		const loftyHandleData = async () => {
		}
		loftyHandleData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetonecaso_69444a8ee307249250093aa0({
					idcaso: match.params.idcaso,
				});
				setloftyres_69444a8ee307249250093aa0_component_i17de7(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetonecaso_69444a8ee307249250093aa0({
					idcaso: match.params.idcaso,
				});
				setloftyres_69444a8ee307249250093aa0_component_iekd72(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetonecaso_69444a8ee307249250093aa0({
					idcaso: match.params.idcaso,
				});
				setloftyres_69444a8ee307249250093aa0_component_i5gz7o(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);

	useEffect(() => {
		const handleLoftyData = async () => {
			try {
				const responseLoftyApps = await customgetcasos_69441e8de307249250092f36({
				});
				setloftyres_69441e8de307249250092f36_component_i766ys(responseLoftyApps.data);
			} catch (loftyerror) {
			}
		}
		handleLoftyData();
	}, []);


	function function_redirigircontactanos_69461c188e5aed52dc8d6166() {
		history.push("https://wa.me/50487475208");
	}


  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id694446088e5aed52dc8c4dac" >

      <div id="icuq" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/soluciones"
        type=""
      >
        <>Soluciones</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobregrowth"
        type=""
      >
        <>Sobre Growth</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="//casosdeexito"
        type=""
      >
        <>Casos de Éxito</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/blog"
        type=""
      >
        <>Blog</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contactanos"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      <div id="ibznw" className="">
      
        <a
          target=""
          className=""
          id="ig3obt"
          href="/"
        >
          
      <img
        className=""
        id="ipd1e"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja92k5o.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="ig5a" className="">
      
        <a
          target=""
          className=""
          id="iope"
          href="/soluciones"
        >
          
    <div id="iye9" className="">
    <>SOLUCIONES</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="i848v"
          href="/sobregrowth"
        >
          
    <div id="i8s6k" className="">
    <>SOBRE GROWTH</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="irmrk"
          href="/casosdeexito"
        >
          
    <div id="ib721" className="">
    <>CASOS DE ÉXITO</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="iwshj"
          href="/blog"
        >
          
    <div id="i5dsy" className="">
    <>BLOG</>
    </div>
    
        </a>
        
        <a
          target=""
          className=""
          id="ipsxb"
          href="/contactanos"
        >
          
    <div id="ii21f" className="">
    <>CONTACTO</>
    </div>
    
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="ihxuvq"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i86fmq" className="">
      
      <div id="i1nx3a" className="">
      
      <img
        className=""
        id="i7oc7h"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="i28n3y"
          href="#"
        >
          
      <img
        className=""
        id="isiqha"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpiasyr.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i7e9bk"
          href="#"
        >
          
      <img
        className=""
        id="iakpui"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieb1l.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i1ecib"
          href="#"
        >
          
      <img
        className=""
        id="i3quxz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpieyc5.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="im948x"
          href="#"
        >
          
      <img
        className=""
        id="ieo7pp"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpifmoh.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
      <img
        className=""
        id="i32dno"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i3v7pk" className="">
      
      <div id="igro49" className="">
      
      <div id="i9kitk" className="">
      
      <div className="" id="iqxoha">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="iu5qne">
        <>Blog </>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
      <div className="" id="ibtwxs">
        
      <p className="MsoNormal " id="">
        
      <span className="" id="ibgcj">
        <>CÓMO LA
INNOVACIÓN DIGITAL ESTÁ TRANSFORMANDO LOS NEGOCIOS</>
    <div id="" className="">
    
    </div>
    
      </span>
      
      </p>
      
      </div>
      
      <div className="" id="i7gcar">
        <>Publicado el: 26 de agosto, 2025</>
      <br className="" id="" />
      <>Por: [Nombre del autor]</>
      </div>
      <>
        </>
      </div>
      
      <div id="imfv8r" className="">
      
      <img
        className=""
        id="icrxvd"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgti270a.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="imj4ss"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="ibs0ik" className="">
      
      <div id="ifcj8m" className="">
      
      <img
        className=""
        id="ioukt4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="ialaig"
          href="#"
        >
          
      <img
        className=""
        id="ig2kqn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjafo5a1.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
      <img
        className=""
        id="iuo4sf"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="ibeal8" className="">
      
      <div id="i8dniq" className="">
      
      <div id="iqf8wf" className="">
      
      <div className="" id="iaju4f">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="iei3a9">
        <>Blog </>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
        <div id="if6s7z" className="">
        
        <div className="" id="iwhysc">
          
      <div id="ioja6j" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
        </div>
        
        <div id="iqz36d" className="">
        
      <div className="" id="i9y01g">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i443nq">
        <>Publicado el:</>
      </span>
      
      </div>
      
        <div className="" id="ilnwmi">
          
      <div id="ib1zd3" className="">
      <>
         &#123;&#123; fechapublicacionbcfjh &#125;&#125;
        </>
      </div>
      
        </div>
        
        </div>
        
        <div id="i31sjn" className="">
        
      <div className="" id="ipwom9">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="i41tvy">
        <>Por:</>
      </span>
      
      </div>
      
        <div className="" id="i8liq4">
          
      <div id="ilfc9t" className="">
      <>
         &#123;&#123; autor &#125;&#125;
        </>
      </div>
      
        </div>
        
        </div>
        <>
        </>
      </div>
      
      <div id="i2uron" className="">
      
      <img
        className=""
        id="ib25ft"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgti270a.jpg"
        alt="undefined"
      />
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ixrxvl"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i5702c" className="">
      
      <div id="ivl7uh" className="">
      
      <img
        className=""
        id="iuxdpx"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      
        <a
          target=""
          className=""
          id="i43o4g"
          href="#"
        >
          <>
        </>
        </a>
        
      <img
        className=""
        id="imyacc"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpi735c.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iahw6l" className="">
      
      <div id="in5847" className="">
      
      <div id="i1wiaf" className="">
      
      <div className="" id="ipyel3">
        
      <span className="" id="">
        
      </span>
      
    <div id="" className="">
    
      <span className="" id="i0557t">
        <>Caso de Éxito</>
      </span>
      
    </div>
    
      </div>
      <>
        </>
      </div>
      
        <div id="i17de7" className="">
        
        <div className="" id="ibqnbm">
          
          <div className="" id="">
            {loftyres_69444a8ee307249250093aa0_component_i17de7?.titulo}
          </div>
          
        </div>
        
        <div className="" id="i8pphc">
          
          <div className="" id="">
            {loftyres_69444a8ee307249250093aa0_component_i17de7?.autor}
          </div>
          
        </div>
        
        <div className="" id="ihu239">
          
          <div className="" id="if9nuo">
            {loftyres_69444a8ee307249250093aa0_component_i17de7?.fechapublicacion}
          </div>
          
        </div>
        
        <div className="" id="icftgu">
          
          <div className="" id="">
            {loftyres_69444a8ee307249250093aa0_component_i17de7?.descripcioncorta}
          </div>
          
        </div>
        
        </div>
        <>
        </>
      </div>
      
      <div id="ijy06j" className="">
      
        <div id="iekd72" className="">
        
        <img
          className=""
          id="i7ls0i"
          alt=""
          src={loftyres_69444a8ee307249250093aa0_component_iekd72?.loftyUrl}
        />
        
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i7c4v6" className="">
      
      <div
        id="i68lei"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="ipo6rg" className="">
      
      <div id="i31d6s" className="">
      
      <div id="ivsxbi" className="">
      
      <div className="" id="is8apx">
        <>El futuro del trabajo: cómo la tecnología redefine nuestra manera de vivir</>
      </div>
      <>
        </>
      </div>
      
      <div id="idv6jw" className="">
      
      <div className="" id="ieaodd">
        <>El mundo laboral está cambiando más rápido que nunca. La automatización, la inteligencia artificial y el trabajo remoto han transformado la manera en que las personas se relacionan con sus empleos y empresas. Pero ¿qué significa esto para el futuro de los trabajadores y los negocios?</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="ie6tti" className="">
      
      <div className="" id="iqu12k">
        <>La transformación digital en el entorno laboral</>
      </div>
      <>
        </>
      </div>
      
      <div id="ibxrnl" className="">
      
      <div className="" id="i7xwxk">
        
      <br className="" id="" />
      <>La digitalización no solo ha mejorado la eficiencia, también ha creado nuevas oportunidades de crecimiento. Empresas de todos los tamaños están adoptando herramientas que permiten:</>
      <br className="" id="" />
      <>Colaborar en tiempo real desde cualquier parte del mundo.</>
      <br className="" id="" />
      <>Reducir costos operativos mediante procesos automatizados.</>
      <br className="" id="" />
      <>Ofrecer experiencias personalizadas a clientes y empleados.</>
      <br className="" id="" />
      <>“El futuro del trabajo no se trata de reemplazar personas con máquinas, sino de potenciar las capacidades humanas con tecnología.”</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="i33ojw" className="">
      
      <div className="" id="ilirgk">
        <>Nuevas habilidades para un nuevo mundo</>
      </div>
      <>
        </>
      </div>
      
      <div id="iq4kcw" className="">
      
      <div className="" id="i5riw1">
        
      <br className="" id="" />
      <> El mercado laboral actual exige que los profesionales desarrollen competencias digitales y blandas como:</>
      <br className="" id="" />
      <>1. Pensamiento crítico y resolución de problemas.</>
      <br className="" id="" />
      <>2. Adaptabilidad al cambio.</>
      <br className="" id="" />
      <>3. Manejo de herramientas digitales y de análisis de datos.</>
      <br className="" id="" />
      <>4.  Comunicación efectiva en entornos híbridos.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      
      <div id="igyr8d" className="">
      
      <div className="" id="i6ikee">
        <>El futuro del trabajo ya está aquí. Las empresas que abracen la innovación estarán mejor preparadas para enfrentar los retos del mañana, mientras que los profesionales que inviertan en aprendizaje continuo tendrán más oportunidades de crecer en un mundo cada vez más digital.</>
      <br className="" id="" />
      
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="isdd3d"
        className=""
        data-aos="fade-up"
        data-aos-duration="undefined"
      >
      
      <div id="icfo4g" className="">
      
      <div id="iba2z3" className="">
      
        <div id="i5gz7o" className="">
        
        <div className="" id="i2mdf8">
          
          <div className="" id="">
            {loftyres_69444a8ee307249250093aa0_component_i5gz7o?.titulosecundario}
          </div>
          
        </div>
        
        <div className="" id="icah9z">
          
          <LoftyEditorJsReadOnly id="id4pf7" className="" defaultValue={loftyres_69444a8ee307249250093aa0_component_i5gz7o?.contenido} />
          
        </div>
        
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div id="i17jxt" className="">
      
      <div id="igc5yk" className="">
      
      <div className="" id="ielw3g">
        <>Casos de Éxito que te pueden interesar</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div
        id="iibrgl"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="iqkybj" className="">
      
      <div id="iienf5" className="">
      
      <div id="i7fxy7" className="">
      
      <div id="inzxwr" className="">
      
      <div id="insatf" className="">
      
      <div id="il3oig" className="">
      
      <div className="" id="i5phqf">
        <>Marketing Digital</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i6b0vh">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ivcqgs" className="">
      
        <a
          target=""
          className=""
          id="ink6rd"
          href="#"
        >
          
      <img
        className=""
        id="i7dncy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iqgt7i">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="i8v88l" className="">
      
      <div id="iyz1t8" className="">
      
      <div id="isjm1y" className="">
      
      <div id="i65jnc" className="">
      
      <div className="" id="i1h76n">
        <>Marketing Digital</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ipb69q">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ijn9xz" className="">
      
        <a
          target=""
          className=""
          id="is46i3"
          href="#"
        >
          
      <img
        className=""
        id="iy354v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="idq6ro">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="itemni" className="">
      
      <div id="ioh0jl" className="">
      
      <div id="i6sjc9" className="">
      
      <div id="ipmznw" className="">
      
      <div className="" id="iykqnb">
        <>Marketing Digital</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="ig0kpr">
        <>¿Utiliza actualmente una de las empresas SaaS más importantes ? </>
      <br className="" id="" />
      
      </div>
      
      <div id="ibqsfk" className="">
      
        <a
          target=""
          className=""
          id="iyjz73"
          href="#"
        >
          
      <img
        className=""
        id="ig8gpy"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iks3d4">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="isz6mi"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="i80sfu" className="">
      
      <div id="igujpp" className="">
      
        <div id="iqseoi" className="">
        
        <div id="ipxmg4" className="">
        
      <div id="iyldrp" className="">
      
      <div id="i7n8qj" className="">
      
      <div id="iknhqm" className="">
      
      <div id="iycxab" className="">
      
        <div className="" id="i8r36t">
          
      <div id="io2bja" className="">
      <>
         &#123;&#123; titulo9alhu &#125;&#125;
        </>
      </div>
      
        </div>
        
        <div className="" id="ih4oiv">
          
      <div id="izc5op" className="">
      <>
         &#123;&#123; descripcioncortawz1jgj &#125;&#125;
        </>
      </div>
      
        </div>
        
      <div id="iju6ip" className="">
      
        <a
          target=""
          className=""
          id="idy1nl"
          href={`/article/null`}
        >
          
      <img
        className=""
        id="iik5qs"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgtgskf3.png"
        alt="undefined"
      />
      
      <span className="" id="iy7qp7">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
        </div>
        
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      
      <div
        id="ikbthk"
        className=""
        data-aos="fade-right"
        data-aos-duration="3"
      >
      
      <div id="itf5e9" className="">
      
      <div id="iswcnb" className="">
      
        <div id="i766ys" className="">
        
            {
              loftyres_69441e8de307249250092f36_component_i766ys?.map((loftyitem_69441e8de307249250092f36_component_i766ys) => (
                <div key={loftyitem_69441e8de307249250092f36_component_i766ys._id} className="" id="iu8dx5">
                  
      <div id="iboke3" className="">
      
      <div id="iauld2" className="">
      
        <img
          className=""
          id="igabn4"
          alt=""
          src={loftyitem_69441e8de307249250092f36_component_i766ys?.loftyUrl}
        />
        <>
        </>
      </div>
      
      <div id="icla4i" className="">
      
      <div id="i1ufqy" className="">
      
        <div className="" id="ituwyh">
          
          <div className="" id="">
            {loftyitem_69441e8de307249250092f36_component_i766ys?.titulo}
          </div>
          
        </div>
        
        <div className="" id="itgwto">
          
          <div className="" id="">
            {loftyitem_69441e8de307249250092f36_component_i766ys?.descripcioncorta}
          </div>
          
        </div>
        
      <div id="ip5w6s" className="">
      
        <a
          target=""
          className=""
          id="imlbal"
          href={`/caso/${loftyitem_69441e8de307249250092f36_component_i766ys._id}`}
        >
          
      <span className="material-icons " id="i2wprh">
        
      <span className="material-icons " id="inaznd">
        <>expand_more</>
      </span>
      
      </span>
      
      <span className="" id="i97hn7">
        <>Ver Más</>
      </span>
      
        </a>
        <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
                </div>
              ))
            }
            
        </div>
        <>
        </>
      </div>
      <>
        </>
      </div>
      
      </div>
      <>
        </>
      </div>
      
      <div id="isqkaw" className="">
      
      <div id="inwpbh" className="">
      
      <div id="iblzwv" className="">
      
      <img
        className=""
        id="i2yoxn"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpsbgsp.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="imbbrp" className="">
      
      <div className="" id="i6egud">
        <>¿Listo para crecer con claridad?</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iynesv" className="">
      
      <div id="ibuain" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button2 "
        onClick={async () => {
		function_redirigircontactanos_69461c188e5aed52dc8d6166();
}}

      >
      
      <div id="i4o7pt" className="">
      
      <span className="" id="i1ckiy">
        <>Escríbenos por WhatsApp</>
      </span>
      
      </div>
      
      </button>
      
      <button
        type=""
        name=""
        id="iby52g"
        className=""
        
      >
      
      </button>
      <>
        </>
      </div>
      
      <div id="ilk8u9" className="">
      
      <button
        type=""
        name=""
        id=""
        className="standard_button "
        onClick={async () => {
		function_redirigircontactanos_69461c188e5aed52dc8d6166();
}}

      >
      
      <div id="ih6ehn" className="">
      <>Agenda una cita</>
      </div>
      
      </button>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="iqood4" className="">
      
      <div id="i0zav2" className="">
      
      <img
        className=""
        id="ikl5d2"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja92k5o.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="i8xq45" className="">
      
      <div id="i6foyi" className="">
      
      <div className="" id="iujitq">
        <>1234 Pais, Ciudad, Depto,</>
      <br className="" id="" />
      <> CA</>
      </div>
      <>
        </>
      </div>
      
      <div id="i4bc65" className="">
      
      <div className="" id="i70l12">
        <>+504 123456789</>
      </div>
      <>
        </>
      </div>
      
      <div id="iuze0u" className="">
      
      <div className="" id="ijszb9">
        <>info@marketingdigital.com</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="il5c0x" className="">
      
        <a
          target=""
          className=""
          id="i4z9uq"
          href="/"
        >
          
      <div className="" id="iquufx">
        <>Inicio</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="itsf22"
          href="/soluciones"
        >
          
      <div className="" id="ishxo7">
        <>Soluciones</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i5y1vt"
          href="/sobregrowth"
        >
          
      <div className="" id="ilmr1e">
        <>Sobre Growth</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i0u2kc"
          href="#"
        >
          
        <a
          target=""
          className=""
          id="i36z7a"
          href="//casosdeexito"
        >
          
      <div className="" id="ibmlnj">
        <>Casos de Éxito</>
      </div>
      <>
        </>
        </a>
        <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="ibflgr"
          href="/blog"
        >
          
      <div className="" id="iq4hzi">
        <>Blog</>
      </div>
      <>
        </>
        </a>
        
        <a
          target=""
          className=""
          id="i8pvvw"
          href="/contactanos"
        >
          
      <div className="" id="i37aoh">
        <>Contacto</>
      </div>
      <>
        </>
        </a>
        <>
        </>
      </div>
      
      <div id="i9ndas" className="">
      <>
        </>
      </div>
      <>
        </>
      </div>
      
      <div id="indubl" className="">
      
      <div id="i21uc2" className="">
      <>
        </>
      </div>
      
      <div id="inwhc2" className="">
      
      <div id="ig0f9m" className="">
      
      <img
        className=""
        id="i8uhy6"
        src="https://assetsprojects.s3.amazonaws.com/404pziimgpus7um.png"
        alt="undefined"
      />
      
      <img
        className=""
        id="ippo57"
        src="https://assetsprojects.s3.amazonaws.com/404pziimjam6dd7.png"
        alt="undefined"
      />
      <>
        </>
      </div>
      
      <div id="iwkvyf" className="">
      
      <div className="" id="ig7fxf">
        <>© 2025 Growth Holístico. Todos los derechos reservados</>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      <>
        </>
      </div>
      
        <a
          target=""
          className=""
          id="i81q3d"
          href="https://wa.me/50487475208"
        >
          
      <img
        className=""
        id="ijpcuk"
        src="https://assetsprojects.s3.amazonaws.com/405gznimll0fka3.png"
        alt="undefined"
      />
      <>
        </>
        </a>
        
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
	set_lofty_global_categorias_app: (value) => dispatch(set_lofty_global_categorias(value)),
});


export default connect(mapStateToProps, mapDispatchToProps)(Pcaso);
  